import { Grid2x2, Grid3x3, LayoutGrid } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { SegmentedTabs } from '~/components/common/segmented-tabs';
import type { ProductViewDensity } from '~/features/explorer/types/products-catalog.types';

interface ProductDensityControlProps {
  value: ProductViewDensity;
  onChange: (density: ProductViewDensity) => void;
}

/**
 * Compact ↔ Comfort ↔ Spacious grid-density switch. Client-only view state that
 * drives the card grid's column count — it does not touch any query.
 */
export function ProductDensityControl({ value, onChange }: ProductDensityControlProps) {
  const { t } = useTranslation('explorer');

  return (
    <SegmentedTabs<ProductViewDensity>
      value={value}
      onChange={onChange}
      ariaLabel={t('products.densityAriaLabel')}
      size="icon"
      className="bg-muted h-10 w-auto shrink-0 border-0 sm:max-w-none"
      options={[
        {
          value: 'spacious',
          label: <LayoutGrid className="h-4 w-4" aria-hidden="true" />,
          ariaLabel: t('products.densitySpacious'),
        },
        {
          value: 'comfort',
          label: <Grid2x2 className="h-4 w-4" aria-hidden="true" />,
          ariaLabel: t('products.densityComfort'),
        },
        {
          value: 'compact',
          label: <Grid3x3 className="h-4 w-4" aria-hidden="true" />,
          ariaLabel: t('products.densityCompact'),
        },
      ]}
    />
  );
}
